import type { IconSvgObject } from './types';

const SchoolBell01Icon: IconSvgObject = [
  ["path", { d: "M18 7C16.807 4.06817 13.9174 2 10.5423 2C6.10066 2 2.5 5.58172 2.5 10C2.5 14.4183 6.10066 18 10.5423 18C12.2197 18 13.7772 17.4892 15.0661 16.6153", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M21.5 13C21.5 18.1004 17.1065 21.595 11.4999 21.9671C11.0444 21.9973 10.8167 22.0124 10.6584 21.8642C10.5 21.716 10.5 21.4773 10.5 21V18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["circle", { cx: "19", cy: "12.5", r: "2.5", stroke: "currentColor", strokeWidth: "1.5", key: "2" }],
  ["circle", { cx: "10.5", cy: "10", r: "2", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "3" }]
];

export default SchoolBell01Icon;
